(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hbx-bh').forEach(function (section) {
  const slides = Array.from(section.querySelectorAll('.hbx-bh__slide'));
  const dots   = Array.from(section.querySelectorAll('.hbx-bh__dot'));
  const prevBtn = section.querySelector('.hbx-bh__arrow--prev');
  const nextBtn = section.querySelector('.hbx-bh__arrow--next');

  if (slides.length <= 1) return;

  const speed    = parseInt(section.dataset.speed, 10) || 600;
  const autoplay = section.dataset.autoplay === 'true';

  section.style.setProperty('--ts', speed + 'ms');

  let current = 0;
  let timer   = null;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    dots[current] && dots[current].classList.remove('is-active');
    dots[current] && dots[current].setAttribute('aria-selected', 'false');

    current = (index + slides.length) % slides.length;

    slides[current].classList.add('is-active');
    dots[current] && dots[current].classList.add('is-active');
    dots[current] && dots[current].setAttribute('aria-selected', 'true');
  }

  prevBtn && prevBtn.addEventListener('click', function () {
    goTo(current - 1);
    if (autoplay) resetTimer();
  });

  nextBtn && nextBtn.addEventListener('click', function () {
    goTo(current + 1);
    if (autoplay) resetTimer();
  });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.dataset.index));
      if (autoplay) resetTimer();
    });
  });

  function startTimer() {
    timer = setInterval(function () { goTo(current + 1); }, 5000);
  }

  function resetTimer() {
    clearInterval(timer);
    startTimer();
  }

  if (autoplay) startTimer();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalog-scroller"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hbx-cs').forEach(function(section) {
  const pills = section.querySelectorAll('.hbx-cs__pill');
  const cards = section.querySelectorAll('.hbx-cs__card');
  const countEl = section.querySelector('[data-count-label]');
  const strip = section.querySelector('.hbx-cs__strip');

  function applyFilter(tag) {
    let visible = 0;
    cards.forEach(function(card) {
      const tags = (card.dataset.tags || '').split(/\s+/);
      const show = !tag || tags.indexOf(tag) !== -1;
      card.classList.toggle('is-hidden', !show);
      if (show) visible++;
    });
    if (countEl) countEl.textContent = visible + (visible === 1 ? ' ITEM' : ' ITEMS');
    if (strip) strip.scrollTo({ left: 0 });
  }

  pills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      pills.forEach(function(p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      applyFilter(pill.dataset.tag);
    });
  });

  applyFilter('');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail"]) return;
  try {
    
// ── Variant picker ──
(function() {
  const dataEl = document.getElementById('hbx-pd-data');
  if (!dataEl) return;

  let data;
  try { data = JSON.parse(dataEl.textContent); } catch(e) { return; }

  const selected = data.selected.slice();
  const skuEl    = document.getElementById('hbx-sku');
  const priceEl  = document.getElementById('hbx-price');
  const mainImg  = document.getElementById('hbx-main-img');

  function findVariant() {
    return data.variants.find(function(v) {
      return v.options.every(function(o, i) { return o === selected[i]; });
    });
  }

  function filterThumbs(variantId) {
    // Show generic images always; show variant-specific images only for the selected variant.
    document.querySelectorAll('.hbx-pd__thumb').forEach(function(thumb) {
      const ids = (thumb.dataset.variantIds || '').split(',').filter(Boolean);
      const isGeneric = ids.length === 0;
      const isMine = variantId && ids.indexOf(String(variantId)) !== -1;
      thumb.style.display = (isGeneric || isMine) ? '' : 'none';
      thumb.classList.toggle('is-active', isMine);
    });
  }

  function applyVariant(v) {
    if (!v) return;
    if (skuEl) skuEl.textContent = v.sku || '';
    if (priceEl) priceEl.textContent = v.price;
    if (mainImg && v.image) {
      mainImg.style.opacity = '0';
      setTimeout(function() { mainImg.src = v.image; mainImg.style.opacity = '1'; }, 150);
    }
    filterThumbs(v.id);
  }

  // Initial state: hide other variants' images from the start
  const initial = findVariant();
  if (initial) filterThumbs(initial.id);

  document.querySelectorAll('.hbx-pd__pills').forEach(function(group) {
    const optIndex = parseInt(group.dataset.optionIndex, 10);
    group.addEventListener('click', function(e) {
      const pill = e.target.closest('.hbx-pd__pill');
      if (!pill) return;
      group.querySelectorAll('.hbx-pd__pill').forEach(function(p) { p.classList.remove('is-selected'); });
      pill.classList.add('is-selected');
      selected[optIndex] = pill.dataset.value;
      const label = document.querySelector('[data-opt-current="' + optIndex + '"]');
      if (label) label.textContent = pill.dataset.value;
      applyVariant(findVariant());
    });
  });
})();

// ── Image gallery switcher ──
(function() {
  const thumbs = document.querySelectorAll('.hbx-pd__thumb');
  const mainImg = document.getElementById('hbx-main-img');
  if (!mainImg) return;

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      mainImg.style.opacity = '0';
      setTimeout(function() {
        mainImg.src = thumb.dataset.src;
        mainImg.style.opacity = '1';
      }, 150);
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
})();

// ── Grow Matcher ──
(function() {
  const matcherEl = document.getElementById('hbx-matcher');
  if (!matcherEl) return;

  let matcherData;
  try {
    matcherData = JSON.parse(matcherEl.dataset.matcher);
  } catch(e) { return; }

  const questionsEl = document.getElementById('hbx-matcher-questions');
  const resultEl    = document.getElementById('hbx-matcher-result');
  const titleEl     = document.getElementById('hbx-matcher-title');
  const bodyEl      = document.getElementById('hbx-matcher-body');
  const tipsEl      = document.getElementById('hbx-matcher-tips');

  let answers = {};

  questionsEl.innerHTML = matcherData.questions.map(function(q) {
    return '<div>' +
      '<div class="hbx-matcher__q-label">' + q.label + '</div>' +
      '<div class="hbx-matcher__options">' +
        q.options.map(function(o) {
          return '<button class="hbx-matcher__opt" data-key="' + q.key + '" data-val="' + o + '">' + o + '</button>';
        }).join('') +
      '</div>' +
    '</div>';
  }).join('');

  questionsEl.addEventListener('click', function(e) {
    const btn = e.target.closest('.hbx-matcher__opt');
    if (!btn) return;

    btn.closest('.hbx-matcher__options').querySelectorAll('.hbx-matcher__opt').forEach(function(b) {
      b.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');
    answers[btn.dataset.key] = btn.dataset.val;

    if (Object.keys(answers).length >= matcherData.questions.length) {
      showResult();
    }
  });

  function showResult() {
    var result = matcherData.results.default || {};
    Object.entries(answers).forEach(function(entry) {
      var specificKey = entry[0] + ':' + entry[1];
      if (matcherData.results[specificKey]) {
        result = matcherData.results[specificKey];
      }
    });

    titleEl.textContent = result.title || '';
    bodyEl.textContent  = result.body || '';
    tipsEl.innerHTML    = (result.tips || []).map(function(t) {
      return '<div class="hbx-matcher__tip"><div class="hbx-matcher__tip-dot"></div><span>' + t + '</span></div>';
    }).join('');

    resultEl.classList.add('is-visible');
    resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  const section = document.currentScript.closest('.hbx-pt') ||
                  document.querySelector('.hbx-pt');
  if (!section) return;

  // ── TAB SWITCHING ──
  const tabs   = section.querySelectorAll('.hbx-pt__tab');
  const panels = section.querySelectorAll('.hbx-pt__panel');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const target = tab.dataset.tab;

      tabs.forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function(p) { p.classList.remove('is-active'); });

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      const panel = section.querySelector('#hbx-pt-panel-' + target);
      if (panel) {
        panel.classList.add('is-active');
        const offset = panel.getBoundingClientRect().top + window.scrollY - 160;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      }
    });
  });

  // ── FAQ ACCORDION ──
  section.querySelectorAll('.hbx-pt__faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const item = btn.closest('.hbx-pt__faq-item');
      const isOpen = item.classList.contains('is-open');

      section.querySelectorAll('.hbx-pt__faq-item').forEach(function(i) {
        i.classList.remove('is-open');
        i.querySelector('.hbx-pt__faq-q').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ── HIDE REVIEWS PLACEHOLDER when app injects content ──
  const reviewsTarget = section.querySelector('#shopify-product-reviews');
  const placeholder   = section.querySelector('.hbx-pt__reviews-placeholder');
  if (reviewsTarget && placeholder) {
    const mo = new MutationObserver(function() {
      if (reviewsTarget.children.length > 0) {
        placeholder.style.display = 'none';
        mo.disconnect();
      }
    });
    mo.observe(reviewsTarget, { childList: true, subtree: true });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
